import { render, staticRenderFns } from "./CompanyEmployees.vue?vue&type=template&id=40a21198"
import script from "./CompanyEmployees.vue?vue&type=script&lang=js"
export * from "./CompanyEmployees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports